module.exports = __webpack_public_path__ + "img/TH.ebb70fa1.jpg";